"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const core_1 = require("@material-ui/core/");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
require("./../singleExpert/components/expertBlocks/expertize/expertize.scss");
const ExpertExpertize = (props) => {
    const { open, expert, areas } = props;
    const [selectedAreas, updateAreas] = react_1.default.useState([]);
    const save = () => {
        const updatedAreas = uniqBy_1.default([...expert.areas, ...selectedAreas], 'id');
        props.editExpert({
            key: 'areas',
            val: updatedAreas
        });
        closeModal();
    };
    const add = (val) => {
        if (val) {
            const areas = [...selectedAreas];
            areas.push(Object.assign({}, Object.assign(Object.assign({}, val), { new: true })));
            updateAreas(areas);
        }
    };
    const remove = (data) => {
        const areas = selectedAreas.slice(selectedAreas.indexOf(data.id, 1));
        updateAreas(areas);
    };
    const closeModal = () => {
        updateAreas([]);
        props.triggerModal({
            key: 'experts.expertize',
            val: false
        });
    };
    return (react_1.default.createElement(core_1.Dialog, { open: open, className: "expert-expertise-modal", maxWidth: 'sm', fullWidth: true, onClose: () => closeModal() },
        react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.DialogTitle, { id: "form-dialog-title", className: "mb-10" }, "Add Areas of Expertise"),
            react_1.default.createElement(core_1.DialogContent, { className: "expertize-modal-body" },
                (areas && areas.length) && react_1.default.createElement(Autocomplete_1.default, { id: "areas", className: "choose-expertize", freeSolo: true, options: areas, onChange: (e, v) => add(v), getOptionLabel: (option) => option.name, renderInput: (params) => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: "Areas of Expertise", margin: "normal", variant: "outlined" }))) }),
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: "mt-0" },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: 'paper expertize-item' },
                        react_1.default.createElement("ul", { className: "expertize-list" }, selectedAreas.map((data, key) => {
                            return (react_1.default.createElement("li", { key: key },
                                react_1.default.createElement(core_1.Chip, { className: "expertize-chip-item", label: data.name, onDelete: (data) => remove(data) })));
                        }))))),
            react_1.default.createElement(core_1.DialogActions, { className: "modal-footer-part mt-10" },
                react_1.default.createElement(core_1.Button, { color: "primary", className: 'v2-btn v2-btn-primary', onClick: () => save() }, "Save"),
                react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-tertiary', onClick: () => closeModal(), color: "secondary" }, "Never Mind")))));
};
const mapStateToProps = (state) => {
    const { modals, experts } = state;
    return {
        open: modals.ADMIN.experts.expertize,
        expert: experts.editableExpert,
        areas: experts.areasSubCats
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        submit: () => dispatch(expertsSlice_1.submit()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertExpertize);
